import { render, staticRenderFns } from "./TableDiv.vue?vue&type=template&id=9f8980be&scoped=true&"
import script from "./TableDiv.vue?vue&type=script&lang=js&"
export * from "./TableDiv.vue?vue&type=script&lang=js&"
import style0 from "./TableDiv.vue?vue&type=style&index=0&id=9f8980be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8980be",
  null
  
)

export default component.exports